const NS = 'FeatureContentCarousel';
const CLS = 'featureContentCarousel';
const BLK = '.' + CLS + '-';

export class FeatureContentCarousel {
    constructor(el) {
        this.el = el;
        this.$el = $(el);
        this.$slider = this.$el.find(`.${CLS}-slider`);
        this.$sliderItem = this.$el.find(`.${CLS}-slider-container`);

        this.autoplaySpeed = this.$el.data('autoplay-speed') || 3000;
        this.autoplayOption = this.$el.data('autoplay') || false;

        this.initSlider();
    }

    initSlider() {
        const slickOptions = {
            autoplay: this.autoplayOption,
            autoplaySpeed: this.autoplaySpeed,
            dots: true,
            prevArrow: $(`${BLK}prev`),
            nextArrow: $(`${BLK}next`),
            dotsClass: `${CLS}-slider-dots`,
            speed: 1000,
        };
        this.$slider.slick(slickOptions);
        this.$sliderItem.parent().addClass(`${CLS}-slider-item-parent`);
    }
}
